export enum EHomeSellingOptionActions {
    SimpleSale = "simpleSale",
    CashOffer = "cashOffer",
    Consultation = "consultation"
}

export interface IHomeSellingOptionSubmitValues {
    action: EHomeSellingOptionActions
}